import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {SampleForm} from './sample-form.model';
import * as SampleFormActions from './sample-form.actions';

export const sampleFormsFeatureKey = 'sampleForms';

export interface State extends EntityState<SampleForm> {
  // additional entities state properties
}

export const adapter: EntityAdapter<SampleForm> = createEntityAdapter<SampleForm>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(SampleFormActions.addSampleForm,
    (state, action) => adapter.addOne(action.sampleForm, state)
  ),
  on(SampleFormActions.upsertSampleForm,
    (state, action) => adapter.upsertOne(action.sampleForm, state)
  ),
  on(SampleFormActions.addSampleForms,
    (state, action) => adapter.addMany(action.sampleForms, state)
  ),
  on(SampleFormActions.upsertSampleForms,
    (state, action) => adapter.upsertMany(action.sampleForms, state)
  ),
  on(SampleFormActions.updateSampleForm,
    (state, action) => adapter.updateOne(action.sampleForm, state)
  ),
  on(SampleFormActions.updateSampleForms,
    (state, action) => adapter.updateMany(action.sampleForms, state)
  ),
  on(SampleFormActions.deleteSampleForm,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SampleFormActions.deleteSampleForms,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SampleFormActions.loadSampleForms,
    (state, action) => adapter.setAll(action.sampleForms, state)
  ),
  on(SampleFormActions.clearSampleForms,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
